import { createDerives } from './equilibrium.js';
const TOKENS = ['gens'];
const definitions = {
    derives: createDerives(TOKENS),
    instances: { balances: TOKENS }
};
export default definitions;
